export default __webpack_public_path__ + "static/media/0007.eb915055.WAV";